import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tnq-card',
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card.component.scss',
})
export class CardComponent {
  readonly variant = input<'float' | 'flat' | 'dashed' | 'overflow' | 'offer'>(
    'float',
  );
}
